/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserNameRequestUser
 */
export interface UpdateUserNameRequestUser {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserNameRequestUser
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserNameRequestUser
     */
    firstName: string;
}

/**
 * Check if a given object implements the UpdateUserNameRequestUser interface.
 */
export function instanceOfUpdateUserNameRequestUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "firstName" in value;

    return isInstance;
}

export function UpdateUserNameRequestUserFromJSON(json: any): UpdateUserNameRequestUser {
    return UpdateUserNameRequestUserFromJSONTyped(json, false);
}

export function UpdateUserNameRequestUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNameRequestUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastName': json['last_name'],
        'firstName': json['first_name'],
    };
}

export function UpdateUserNameRequestUserToJSON(value?: UpdateUserNameRequestUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'last_name': value.lastName,
        'first_name': value.firstName,
    };
}

